import React from 'react';
import Header from './Header';
import Footer from './Footer';
// import PromotionDialog from '../PromotionDialog'; // Temporarily disabled

type LayoutProps = {
  children: React.ReactNode;
};

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className='flex flex-col min-h-screen'>
      <Header />
      <main className='flex-grow bg-white'>{children}</main>
      <Footer />
      {/* <PromotionDialog /> */} {/* Temporarily disabled */}
    </div>
  );
};

export default Layout;
